import { Link } from 'react-router-dom';

export default function NavCard({ to, name, coverUrl }) {
  return (
    <Link to={to} className="nav-card-link" aria-label={name}>
      <div className="nav-card">
        <div className="nav-card__media">
          {coverUrl && (
            <img src={coverUrl} alt="" loading="lazy" decoding="async" style={{width:'100%',height:'100%',objectFit:'cover'}} />
          )}
        </div>
        <div className="nav-card__name">{name}</div>
      </div>
    </Link>
  );
}

